<template>
    <div>
        <div class="row">
            <div class="col-sm">
              <h1 class=""><strong>Your Forms</strong></h1>
            </div>
          </div>
          <div class="row u-mb2">
            <div class="col-sm">
              <h2 class="" v-if="!read_only">Below are all your bespoke forms, click any of the forms below to view your users answers</h2>
              <h2 v-else>
                  Click on the forms below to view the answers
              </h2>
            </div>
          </div>
          <div class="Holder" v-for="(item, index) in forms" v-bind:key="item.id">


              <div class="row u-mb1">
                <div class="col-sm">
                    <h4>{{item.title}}</h4>
                </div>
                <div class="col-sm" v-if="showTools">
                    <a class="btn btn-danger float-right text-light" href="#" @click="deleteForm(item.id)" v-if="!read_only">
                        <i class="fas fa-trash"></i>
                        Delete
                    </a>
                    <a class="btn btn-inverse float-right text-light u-mr1" :href="'#/share/'+item.id">
                        <i class="fas fa-share-alt"></i>
                        Share
                    </a>
                     <a class="btn btn-secondary float-right text-light u-mr1" :href="'#/edit/'+item.id" v-if="!read_only">
                        <i class="fas fa-cog"></i>
                        Edit
                    </a>
                    <button class="btn btn-secondary float-right text-light u-mr1"
                          v-clipboard:copy="copyItem(item)"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onCopyError">
                          <i class="far fa-clone"></i>
                          Copy the link
                      </button>
                </div>
              </div>

              <div class="row u-mb1" v-if="item.slug && item.business">
                  <div class="col align-right">
                      <a class="t-secondary" :href="'#/form/' + item.business.slug + '/' + item.slug">{{copyItem(item)}}</a>
                  </div>
              </div>

              <div class="row u-mb3">
                <div class="col-sm">
                  <div class="card">
                    <div class="card-body" v-if="item.loaded">
                      <table class="data-tables" :id="'table'+index">
                        <thead>
                          <tr>
                              <th>Email</th>
                              <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(answer, n) in item.answers" v-bind:key="'answer' + n">
                            <td>{{answer.email}} (submitted - {{dateFormat(answer.created_at)}})
                              <span v-if="answer.consultant_id" style="color:#f57d00">
                                EID:{{answer.consultant_id}}
                              </span>
                            </td>
                            <td style="width:150px;text-align: right;">
                              <a v-if="!item.sign_off" :href="'#/builder/'+answer.id" class="btn btn-secondary u-mr1 btn-small"><i class="fas fa-eye"></i></a>
                              <a v-else  :href="'#/signoff/'+answer.id" class="btn btn-secondary u-mr1 btn-small"><i class="fas fa-eye"></i></a>
                              <a @click="remove(answer.id)" class="btn btn-secondary btn-small text-light"><i class="fas fa-trash"></i></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="card-body" v-else>
                      <div class="align-center u-pt2 u-pb2">
                        <i class="fas fa-spin fa-circle-notch fa-5x"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
    </div>
</template>

<script>


import {alerts} from '@/mixins/alerts.js';
import swal from 'sweetalert';

export default {
    name: 'forms',
    data : function () {
        return {
            profile:{},
            loading:true,
            forms:{}
        };
    },
    mounted : function () {
        //Grab the form for this user
        this.getFormData();
    },
    computed : {
        showTools () {
          if (this.business_id === 1689) {
              let profileId = this.$root.profile.id;
              if (profileId === 22 || profileId === 618 || profileId === 925) {
                  return true;
              }
              // rocket users can still edit
              return this.$root.user_type === 'rocket';
          }
          return true;
        }
    },
    components: {},
    mixins : [alerts],
    methods:{
      dateFormat(date){
        let t = new moment(date);
        if (t.isValid()) {
            return t.format('DD/MM/YYYY')
        }
      },
      copyItem (item) {
          let url = 'https://form.mobilerocket.co.uk/#/';
          if (item.business && item.slug) {
              return url + 'form/' + item.business.slug + '/' + item.slug;
          }
          return url + 'share/' + item.id;
      },
      onCopy () {
        this.successMsg('The link has been copied to you clipboard');
      },
      onCopyError (e) {
        this.errorMsg('We could not copy that to your clipboard.')
      },
      deleteForm : function (id)
      {
        let self=this;
          swal({
            title: "Are you sure?",
            text: "Do you want to delete this form?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
              let params = {}
              self.deleteRequest('forms/'+id, params, self.removeForms);
            }
          });
      },
      getFormData : function (id)
      {
          let params = {
            user_id : this.business_id
          }
          this.getRequest('forms', params, this.processForms);
      },
      getAnswers (i) {
        let form = this.forms[i];
        form.answers = [];
        //init the data tables
        this.axios.get(this.$root.env_url+'/api/v1/form/forms/' + form.id + '/answers')
          .then(response => {
            form.answers = response.data;
            form.loaded = true;
            console.log('form answers', form.answers);
              setTimeout(function() {
                $('#table' + i).DataTable( {
                    "lengthChange": false
                });
            }, 5);
          })
          .catch(error => {
            console.error('no answers for form', form);
            form.loaded = true;
          });
      },
      processForms : function (response)
      {
          if (response.error) {
              this.errorMsg(error);
              console.error('error', error);
          } else {
              this.forms = [];
              let r = response.data;
              for (var i = 0; i < r.length; i++) {
                  let form = r[i];
                  form.loaded = false;
                  this.forms.push(form);
                  this.getAnswers(i);
              }
          }
      },
      remove(id)
      {
        let self =this;
        swal({
            title: "Are you sure?",
            text: "Do you want to delete this persons answers?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
              let params = {}
              self.deleteRequest('answers/'+id, params, self.removeForms);
            }
          });

      },
      removeForms : function (response)
      {
          let self = this;
          if(response.error)
          {
            this.errorMsg(error);
          }else{
            //remove it from the array
            location.reload()
          }

      },
    },
    watch : {}
}
</script>

<style lang="scss">

@import '../sass/variables.scss';

.data-tables{
    padding-top: 1em !important;
    margin-bottom: 3em !important;
}
.dataTables_filter{
  input{
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
  }
}
</style>
